import { useEffect, useState } from "react";
import { mastheadNav, tickerItems } from "@/mocks/home";

export default function Masthead() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const tickerRow = [...tickerItems, ...tickerItems];

  return (
    <>
      <header
        className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
          scrolled
            ? "border-b border-background-200 bg-background-50/95 backdrop-blur-md"
            : "border-b border-transparent bg-background-50"
        }`}
      >
        {/* 运营工具条 */}
        <div className="hidden w-full items-center justify-between border-b border-background-200 px-8 py-2 text-xs text-foreground-600 md:flex">
          <div className="flex items-center gap-5">
            <span className="font-label tracking-wide">2026年9月12日 星期六</span>
            <span className="hidden items-center gap-1.5 lg:flex">
              <span className="relative flex h-2 w-2 items-center justify-center">
                <span className="absolute inline-flex h-2 w-2 animate-pulse-ring rounded-full bg-primary-500" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
              </span>
              今日已更新 128 条
            </span>
          </div>
          <div className="flex items-center gap-6">
            <a href="#top-ranking" className="transition-colors hover:text-primary-600">
              榜单规则
            </a>
            <a href="#topic-wall" className="transition-colors hover:text-primary-600">
              话题墙
            </a>
            <a
              href="#subscribe"
              className="whitespace-nowrap rounded-full border border-primary-300 px-3 py-1 text-primary-700 transition-colors hover:bg-primary-50"
            >
              订阅每日瓜报
            </a>
          </div>
        </div>

        {/* 报头 */}
        <div className="flex w-full items-center justify-between gap-4 px-4 py-4 md:px-8 md:py-6">
          <div className="hidden flex-1 items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-foreground-500 md:flex">
            <span>TOP 榜</span>
            <span className="h-3 w-px bg-background-300" />
            <span>热度排行</span>
          </div>

          <a href="#top" className="flex flex-1 flex-col items-center justify-center md:flex-none">
            <h1 className="whitespace-nowrap font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-5xl">
              黑料每日
            </h1>
            <span className="mt-1 font-label text-[10px] uppercase tracking-[0.4em] text-primary-600 md:text-xs">
              Daily Gossip Digest
            </span>
          </a>

          <div className="flex flex-1 items-center justify-end gap-3">
            <div className="hidden items-center gap-2 rounded-full border border-background-300 bg-background-50 px-3 py-2 md:flex">
              <span className="flex h-4 w-4 items-center justify-center text-foreground-500">
                <i className="ri-search-line text-sm" />
              </span>
              <input
                type="text"
                placeholder="搜话题 / 找瓜"
                className="w-32 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none lg:w-40"
              />
            </div>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setMenuOpen((v) => !v)}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-300 text-foreground-800 md:hidden"
            >
              <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
            </button>
          </div>
        </div>

        {/* 主导航 */}
        <nav className="flex w-full items-center gap-1 overflow-x-auto border-t border-background-200 px-2 md:justify-center md:gap-2 md:px-8">
          {mastheadNav.map((item, idx) => (
            <a
              key={item.label}
              href={item.href}
              className={`whitespace-nowrap border-b-2 px-3 py-3 text-sm transition-colors ${
                idx === 0
                  ? "border-primary-500 font-medium text-primary-700"
                  : "border-transparent text-foreground-700 hover:border-accent-400 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* 移动端菜单 */}
        {menuOpen && (
          <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
            <div className="mb-3 flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-2">
              <span className="flex h-4 w-4 items-center justify-center text-foreground-500">
                <i className="ri-search-line text-sm" />
              </span>
              <input
                type="text"
                placeholder="搜话题 / 找瓜"
                className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              />
            </div>
            <div className="flex flex-wrap gap-2">
              {mastheadNav.map((item) => (
                <a
                  key={`m-${item.label}`}
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="rounded-full bg-secondary-100 px-3 py-1.5 text-sm text-secondary-900"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </header>

      {/* 运营跑马灯 */}
      <div className="flex w-full items-center overflow-hidden bg-primary-950">
        <div className="flex shrink-0 items-center gap-2 bg-accent-500 px-4 py-2">
          <span className="flex h-4 w-4 items-center justify-center text-primary-950">
            <i className="ri-fire-fill text-sm" />
          </span>
          <span className="whitespace-nowrap font-label text-xs font-semibold tracking-wide text-primary-950">
            实时热榜
          </span>
        </div>
        <div className="relative flex-1 overflow-hidden py-2">
          <div className="flex w-max animate-marquee">
            {tickerRow.map((text, i) => (
              <span key={i} className="flex items-center gap-3 whitespace-nowrap px-6 text-xs text-background-100">
                <span className="h-1 w-1 rounded-full bg-accent-500" />
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}